export const googleSearchConsoleDataTypes = [
  "clicks",
  "impressions",
  "ctr",
  "position",
];
export function getPageSpeedDataTypes(customType) {
  let types = ["fcp", "lcp", "fid", "cls", "inp", "ttfb", "performance"];
  if (customType) types.push(customType);
  return types;
}
